<mat-card>
  <mat-card-title>Tenant History Log</mat-card-title>
  <mat-card-subtitle>Add a comment when major configuration changes are made to this tenant, giving a summary of what was changed and why. This is particularly important when non-standard changes are made, such as integrations or major workflow changes.</mat-card-subtitle>
  <mat-card-content>
    <form class="new-form">
      <mat-form-field>
        <mat-label>Add a comment</mat-label>
        <textarea
          matInput
          #newComment
          cdkTextareaAutosize
          cdkAutosizeMinRows="5"
          cdkAutosizeMaxRows="25"
          maxlength="4000"
          required
        ></textarea>
        <mat-hint align="start"><a href="https://www.markdownguide.org/basic-syntax/" target="_blank">markdown supported</a></mat-hint>
        <mat-hint align="end">{{newComment.value.length}} / 4000</mat-hint>
      </mat-form-field>
      <br><br>
      <button mat-raised-button (click)="submitComment(newComment)" [disabled]="newComment.value.length < 1 ? true : null">
        Submit
      </button>
    </form>
    <div class="history">
      @for (comment of comments; track comment) {
        <div class="comment">
          <div class="blob"></div>
          <div class="text">
            <markdown ngPreserveWhitespaces>
              {{ comment.CommentText }}
            </markdown>
          </div>
          <span class="caption"
            >{{ comment.Author }} <span [title]="comment.CommentDate | date: 'long'">{{ comment.CommentDate | timeago:false}}</span></span>
            @if (comment.CanDelete) {
              <span class="caption right">
                @if (!comment.deleting) {
                  <button mat-button (click)="comment.deleting = true">Delete Comment</button>
                }
                @if (comment.deleting) {
                  <button mat-icon-button color="warn" (click)="deleteComment(comment)" title="Delete it"><mat-icon>delete</mat-icon></button>
                }
                @if (comment.deleting) {
                  <button mat-icon-button (click)="comment.deleting = false" title="Cancel"><mat-icon>close</mat-icon></button>
                }
              </span>
            }
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
